'use strict';

var FlightAnalysisModePanelDirective = function FlightAnalysisModePanelDirective() {
  return {
    restrict: 'E',
    controller: 'FlightAnalysisModePanelController',
    template: require('../templates/flight-analysis-mode-panel.html'),
    scope: true
  };
};
FlightAnalysisModePanelDirective.$inject = [];
module.exports = FlightAnalysisModePanelDirective;